module.exports = __webpack_public_path__ + "static/media/3 - Delegation - Darlin I Think About U.aa56cb28.mp3";